export default __webpack_public_path__ + "static/pattern-bg-8d4301160827219f9be5196aca111864.png";